import React, { useEffect, useState } from 'react'
import { Text, View, TouchableOpacity, StatusBar, StyleSheet } from 'react-native'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import theme from '../../../../theme'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../../navigation/stacks/NavigationStack'
import styles from './InputButtonItemStyles'

interface InputButtonItemProps {
    item: FormContentsModel
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
}

export const InputButtonItem = React.memo(({ item, form_id, schedule_id, store_id, checkComplete }: InputButtonItemProps) => {
    // console.log('Type heladeraaa ---------->>>>>>') //item.secondary_actions[0]
    const [answer, setAnswer] = useState('')
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()

    useEffect(() => {
        if (item?.old_response) {
            setAnswer(item.old_response.question_input || '')
        }
    }, [item?.old_response])

    const create_answer = async (inputText: string) => {
        const answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: [],
            option_selected_id: [],
            question_id: item._id,
            media: '',
            question_text: item.title,
            score: '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: inputText,
            field_media: '',
            field_text: '',
            questionScore: item.questionScore,
            type: item.input_type.type,
            ponderar: item.questionScore && item.questionScore > 0, // [7, 8, 14, 18].includes(item.input_type.type),

            question: item.title,
            questionOptionSelected: [],
            questionOptionSelectedText: [],
            questionType: {
                title: item.input_type.title,
                type: item.input_type.type,
                id: item.input_type._id,
            },
            questionPrice: '',
            description: '',
            tag: '',
            questionImage: '',
            questionInput: inputText,
        }

        updateFormAnswerSchedule({ newAnswer: answer, schedule_id, form_id, store_id })
        await checkComplete(answer)
    }

    const handleButtonPress = () => {
        const form = item.secondary_actions[0]['form']
        console.log('form to open: ', form)
        navigation.push('ExecutionView', {
            forms: form,
            selectedIndex: 0,
            schedule_id: schedule_id,
            store_id: store_id,
            storeInfo: null,
            checkin_id: null,
            isCreateHeladera: true, // Nuevo parámetro para distinguir creación de heladera
        })
    }

    return (
        <View style={styles.buttonContainer}>
            <TouchableOpacity onPress={() => handleButtonPress()} style={styles.borderButton}>
                <Text style={styles.borderButtonText}>{item?.title}</Text>
            </TouchableOpacity>
        </View>
    )
})
